import PropTypes from 'prop-types';
import React from 'react';

import styles from './ButtonGroup.module.scss';

const ButtonGroup = ({ label, options, onSelect, disabled = false, fullWidth = false }) => (
  <div
    role="group"
    aria-label={label}
    className={`${styles.group} ${fullWidth ? styles.fullWidth : ''}`.trim()}
  >
    {options.map((option) => {
      let toneClass = '';
      if (option.active) toneClass = styles[option.activeTone ?? 'activeNeutral'];
      else if (option.primary) toneClass = styles.primary;

      return (
        <button
          key={option.value}
          type="button"
          className={`${styles.button} ${toneClass}`.trim()}
          disabled={disabled || option.disabled}
          aria-pressed={option.active}
          onClick={() => onSelect?.(option.value)}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);

ButtonGroup.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      active: PropTypes.bool,
      primary: PropTypes.bool,
      activeTone: PropTypes.oneOf(['activeNeutral', 'activeDanger', 'activeWarning']),
      disabled: PropTypes.bool,
    }),
  ).isRequired,
  onSelect: PropTypes.func,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

export default ButtonGroup;
